var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "nav",
    { staticClass: "menu-tab-bar", attrs: { "aria-label": "Menu navigation" } },
    [
      _c("div", {
        staticClass: "menu-tab-bar__bg",
        attrs: { "aria-hidden": "true" },
      }),
      _vm._l(_vm.visibleTabs, function (tab) {
        return _c(
          "button",
          {
            key: tab.id,
            staticClass: "menu-tab-bar__tab",
            class: { "is-active": _vm.isActive(tab.page) },
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                return _vm.selectTab(tab.page)
              },
            },
          },
          [
            _c("span", { staticClass: "menu-tab-bar__icon-wrap" }, [
              _c("img", {
                staticClass: "menu-tab-bar__icon",
                attrs: { src: tab.icon, alt: "" },
              }),
              tab.badge
                ? _c("span", { staticClass: "menu-tab-bar__badge" }, [
                    _vm._v(_vm._s(tab.badge)),
                  ])
                : _vm._e(),
            ]),
            _c("span", { staticClass: "menu-tab-bar__label" }, [
              _vm._v(_vm._s(_vm.$t(tab.label))),
            ]),
          ]
        )
      }),
      _c(
        "div",
        {
          staticClass: "menu-tab-bar__lines",
          attrs: { "aria-hidden": "true" },
        },
        [
          _c("div", {
            staticClass: "menu-tab-bar__line-active",
            style: { width: _vm.activeLineWidth, left: _vm.activeLineLeft },
          }),
          _c("div", { staticClass: "menu-tab-bar__line-inactive" }),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }